<template>
  <finished-join-request-data-table
    :allfinishedparticipants="allfinishedparticipants"></finished-join-request-data-table>

</template>

<script>
import FinishedJoinRequestDataTable from './FinishedJoinRequestDataTable.vue';

export default {
  props: {
    allfinishedparticipants: {
      type: Array,
      required: true
    }
  },
  components: { FinishedJoinRequestDataTable },
}
</script>